export default "__VITE_ASSET__0LMCfxIf__"